import { observable, computed, action, set } from "mobx";
import { config } from "app-common";
import { isInteger, isNumeric } from "argon-common";
import * as api from "./Api";

export default class AppStore {
	//33367420
	//1199107

	@observable name = "";
	@observable number = "";
	@observable email = "";
	@observable phone = "";

	// @observable number = '1199107';
	// @observable email = 'office@bioeel.ro';
	// @observable phone = '0000000000';

	@observable isProcessing = false;

	validationErrors = observable({
		name: false,
		number: false,
		email: false,
		phone: false
	});

	@action
	setField = field => {
		set(this, field);
	};

	@action
	process = async () => {
		if (!this.canProcess()) return;

		if (!this.isEmpty(this.number)) {
			await this.processFiscalIdentificationNumber();
		} else {
			await this.processName();
		}
	};

	@action
	processFiscalIdentificationNumber = async () => {
		this.isProcessing = true;

		var results = await api.addLead({
			number: this.number,
			name: this.name,
			email: this.email,
			phone: this.phone
		});

		if (results.redirectTo === "") return;

		const url = results.redirectTo.substring(0, results.redirectTo.length - 1);

		const redirect = `${url}?fin=${results.id}`;
		window.location = redirect;

		this.isProcessing = false;
	};

	@action
	processName = async () => {
		this.isProcessing = true;

		var results = await api.search({
			name: this.name
		});

		if (results.count > 1) {
			const url = results.redirectTo.substring(0, results.redirectTo.length - 1);

			const redirect = `${url}?criteria=${this.name}`;
			window.location = redirect;
		} else if (results.item) {
			this.number = results.item.fiscalIdentificationNumber;
			this.email = results.item.email;
			this.phone = results.item.phone;
			await this.processFiscalIdentificationNumber();
		}

		this.isProcessing = false;
	};

	@action
	canProcess = () => {
		set(this.validationErrors, {
			name: false,
			number: false,
			email: false,
			phone: false
		});

		if (this.isEmpty(this.number) && this.isEmpty(this.name)) {
			this.validationErrors.number = true;
			this.validationErrors.name = true;
		} else {
			if (!this.isEmpty(this.number) && !this.validateCui(this.number)) {
				this.validationErrors.number = true;
			}
		}

		return !this.validationErrors.number && !this.validationErrors.name;
	};

	isEmpty = value => {
		return !value || value === "";
	};

	validateCui = value => {
		return isInteger(value) && value.length >= 3;
	};

	validateEmail = value => {
		const emailExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		const valid = emailExp.test(value);
		return valid;
	};

	validatePhone = value => {
		return isInteger(value) && value.length === 10;
	};
}
